import { render, staticRenderFns } from "./ownGoodsLibrary copy.vue?vue&type=template&id=6bf7c9e5&scoped=true"
import script from "./ownGoodsLibrary copy.vue?vue&type=script&lang=js"
export * from "./ownGoodsLibrary copy.vue?vue&type=script&lang=js"
import style0 from "./ownGoodsLibrary copy.vue?vue&type=style&index=0&id=6bf7c9e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7c9e5",
  null
  
)

export default component.exports